import React, {FC, useContext, useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {Field, Form, Formik, FormikProps} from 'formik';
import {useTranslation} from 'react-i18next';

import {FORM_FIELD_UPDATE_OPTION_VARIABLE} from 'appRedux/actions/forms';
import {FieldOptionType, OptionUpdateVariableFormType} from 'appRedux/actions/forms/types';

import {AlertContext} from 'contexts/alert/context';

import FormikTextInput from 'components/AgentScreenComponents/_form/FormBuilderTextInput';
import {validationSchema} from 'components/Forms/FormBuilder/FieldForm/partialsMetadataOptions/validation';

import {preventSendForm} from 'helpers/index';

interface ComponentType {
    keyIndex: number;
    isDisabled: boolean;
    option: FieldOptionType;
}

const FormFieldOptionMetadataForm: FC<ComponentType> = ({keyIndex, option, isDisabled}) => {
    const [t] = useTranslation();
    const dispatch = useDispatch();

    const {showAlert} = useContext(AlertContext);

    const {uuid, formVariable, title} = option;

    const submitUpdateForm = useCallback(
        data => dispatch({type: FORM_FIELD_UPDATE_OPTION_VARIABLE.REQUEST, payload: data}),
        [dispatch],
    );

    const onSubmitClicked = (values: OptionUpdateVariableFormType) => {
        submitUpdateForm({
            uuid,
            ...values,
            showAlert,
        });
    };

    return (
        <Formik
            initialValues={{
                formVariable: formVariable ?? '',
            }}
            onSubmit={(values, {setErrors}) => {
                onSubmitClicked({
                    ...values,
                    setErrors,
                });
            }}
            validationSchema={validationSchema}
        >
            {(formik: FormikProps<OptionUpdateVariableFormType>) => {
                const label = `${t('orguser.forms.formField.option')} ${keyIndex + 1}: ${title}`;
                return (
                    <Form onKeyDown={preventSendForm}>
                        <Field
                            required
                            name="formVariable"
                            label={label}
                            placeholder={label}
                            component={FormikTextInput}
                            onBlur={formik.submitForm}
                            disabled={isDisabled}
                        />
                    </Form>
                );
            }}
        </Formik>
    );
};

export default FormFieldOptionMetadataForm;
